import * as React from "react";

import { style, MyIconProps } from "./MyIcons";

export const Close = (props: MyIconProps): React.ReactElement => {
  return (
    <svg
      ref={props.elementRef}
      className={props.className}
      style={{ ...style(props), ...props.style }}
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    >
      <path d="M6.67522 6.68025L17.2747 17.2798" />
      <path d="M17.2747 6.68025L6.67521 17.2798" />
    </svg>
  );
};
